import { render, staticRenderFns } from "./paperListPage.vue?vue&type=template&id=7fa93b90&scoped=true"
import script from "./paperListPage.vue?vue&type=script&lang=js"
export * from "./paperListPage.vue?vue&type=script&lang=js"
import style0 from "./paperListPage.vue?vue&type=style&index=0&id=7fa93b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa93b90",
  null
  
)

export default component.exports